module.exports = __webpack_public_path__ + "img/racha-frame.9d444a29.svg";